/* Адаптер экрана входа (Login.tsx) поверх реального API ядра — маппинг бэк→форма экрана
   (см. .claude/FRONT-PORT.md Шаг 5). Брендинга у ядра нет — честный нейтральный дефолт. */
import { apiFetch, ApiError } from "../api/client";
import * as authApi from "../api/auth";
import { t } from "../i18n/i18n";
// Окно частоты входа синхронизировано с core/internal/door/internal/session/ratelimit.go (loginRateWindow);
// точного остатка бэк не отдаёт — countdown приблизительный, следующий ответ бэка есть истина.
const LOGIN_RATE_WINDOW_SEC = 300;
function toLoginUser(u) {
    return { id: u.userId, name: u.displayName, email: u.email };
}
export function makeLoginApi() {
    // Одноразовый пароль, которым вошли при must_change_password — нужен бэку как
    // current_password в POST /api/auth/password (challengeToken экрана его не несёт).
    let pendingCurrentPassword = null;
    return {
        async getBranding() {
            return { tenant: "", tagline: undefined, note: null, version: "", supportEmail: "support@osnova.ru" };
        },
        async login({ email, password }) {
            let body;
            try {
                body = await authApi.login(email, password);
            }
            catch (e) {
                if (e instanceof ApiError) {
                    if (e.status === 401)
                        return { status: "invalid" };
                    if (e.status === 429)
                        return { status: "locked", retryAfterSec: LOGIN_RATE_WINDOW_SEC };
                }
                throw e;
            }
            if (body.status === "two_factor") {
                return { status: "two_factor", challengeToken: body.challengeToken };
            }
            const me = await authApi.me();
            if (me.mustChangePassword) {
                pendingCurrentPassword = password;
                return { status: "must_change_password", challengeToken: me.userId, email: me.email };
            }
            return { status: "ok", user: toLoginUser(me) };
        },
        async changePassword({ password }) {
            if (!pendingCurrentPassword) {
                return { status: "rejected", message: t("auth.login.change_password_expired") };
            }
            try {
                await apiFetch("/api/auth/password", {
                    method: "POST",
                    body: { current_password: pendingCurrentPassword, new_password: password },
                });
            }
            catch (e) {
                if (e instanceof ApiError && (e.status === 401 || e.status === 400)) {
                    return { status: "rejected", message: e.message };
                }
                throw e;
            }
            pendingCurrentPassword = null;
            const me = await authApi.me();
            return { status: "ok", user: toLoginUser(me) };
        },
        async verifyTwoFactor({ challengeToken, code, backup }) {
            const r = await authApi.verifyTwoFactor(challengeToken, code, backup);
            if (r.status === "ok")
                return { status: "ok", user: { id: r.user.id, name: r.user.name, email: "" } };
            if (r.status === "locked")
                return { status: "locked", retryAfterSec: r.retryAfterSec };
            if (r.code === "identity.challenge_expired")
                return { status: "challenge_expired" };
            return { status: "invalid" };
        },
    };
}
